export const IS_DEV: boolean = import.meta.env.VITE_APP_ENV === "dev"
export const IS_UAT: boolean = import.meta.env.VITE_APP_ENV === "uat"
export const IS_PROD: boolean = import.meta.env.VITE_APP_ENV === "prod"
export const SERVER_URL: string = import.meta.env.VITE_APP_SERVER_URL
export const FINCH_URL: string = import.meta.env.VITE_APP_FINCH_URL
export const FRESHPAINT_TOKEN: string = import.meta.env.VITE_APP_FRESHPAINT_TOKEN
export const FRESHPAINT_SCRIPT_URL = "/js/freshpaint.v1.3.0.js"
export const SMARTY_KEY: string = import.meta.env.VITE_APP_SMARTY_KEY
export const SENTRY_URL = "https://cd56f47d0cd74d34b699f8f8ac4fd5de@o675910.ingest.sentry.io/5770691"

export const QUEST_LAB_LOCATOR_LINK = "https://appointment.questdiagnostics.com/find-location/as-location-finder"
export const LABCORP_LAB_LOCATOR_LINK = "https://www.labcorp.com/labs-and-appointments"
export const LABCORP_DRUG_AND_ALCOHOL_LAB_LOCATOR_LINK = "https://www.labcorpsolutions.com/ots/locator.do"
export const CVS_MINUTE_CLINIC_LOCATOR_LINK = "https://www.cvs.com/minuteclinic/clinic-locator/"

export const MOBILE_APP_DOWNLOAD_LINK = "https://onelink.to/vitableapp"
export const VITABLE_SUPPORT_PHONE = "484-416-0769"
export const VITABLE_SUPPORT_EMAIL = "support@vitablehealth.com"
export const FINCH_AUTH_GUIDE_URL = "https://support.tryfinch.com/collections/9565019353-authentication-guides"
export const SUPPORTED_HRIS_PROVIDERS_URL =
  "https://intercom.help/vitable-health-employer-help-center/en/articles/15218883-supported-hris-providers"

export const PRE_OPEN_ENROLLMENT_PERIOD_LENGTH__DAYS = 30

export const MOOV_FACILITATOR_ACCOUNT_ID = import.meta.env.VITE_APP_MOOV_FACILITATOR_ACCOUNT_ID
